module.exports = __webpack_public_path__ + "img/WechatIMG2748.9d8bd38e.png";